export default {
  name: 'Article list section - 10',
  tab: 'article list',
  type: 'category-listing-default-section',
  content: {
    title: 'Category listing section',
    introtext: '',
    articles:
      '[{"article-title":"Article 1","article-introtext":"<p>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Etiam porta sem malesuada magna mollis euismod.</p>","article-image":"/storage/media/samples/duy-pham-6iYs78oCiZA-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"},{"article-title":"Article 2","article-introtext":"<p>Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget urna mollis ornare vel eu leo.</p>","article-image":"/storage/media/samples/luca-bravo-A-fubu9QJxE-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"},{"article-title":"Article 3","article-introtext":"<p>Maecenas faucibus mollis interdum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>","article-image":"/storage/media/samples/chris-abney-qLW70Aoo8BE-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"outlined","button-background-color":"var(--primary-color)","button-text-color":"inherit"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '0',
    'padding-top': '60px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h2',
    'introtext-color': 'inherit',
    'article-title-color': 'inherit',
    'article-title-font-weight': 'lighter',
    'article-title-tag': 'h6',
    'article-introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'article-columns': '3',
    'content-box': '0',
    'content-box-wrap': 'item',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
